(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-bday10-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-bday10-countdown')) {
    class PVBday10Countdown extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.label = this.querySelector('[data-bday10-label]');
        this.clock = this.querySelector('[data-bday10-time]');
        this.londonDate = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        if (!Number.isFinite(this.deadline) || !this.label || !this.clock) return;
        this.update();
        if (Date.now() < this.deadline) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const notice = this.closest('.product-price__promo-notice[data-promo-code="BDAY10"]');
        if (!remaining) {
          window.clearInterval(this.interval);
          if (notice) {
            notice.hidden = true;
            notice.style.display = 'none';
          } else {
            this.hidden = true;
          }
          return;
        }
        const tonight = this.londonDate.format(now) === this.londonDate.format(this.deadline - 1);
        const label = tonight ? this.dataset.labelToday : this.dataset.labelLater;
        if (this.label.textContent !== label) this.label.textContent = label;
        const pad = value => String(value).padStart(2, '0');
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((tonight ? remaining : remaining % 86400) / 3600);
        const minutes = pad(Math.floor(remaining % 3600 / 60));
        const seconds = pad(remaining % 60);
        this.clock.textContent = tonight
          ? `${hours}h ${minutes}m ${seconds}s`
          : `${days ? `${days}d ` : ''}${hours}h ${minutes}m`;
        this.hidden = false;
      }
    }
    customElements.define('pv-bday10-countdown', PVBday10Countdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-cen10-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-cen10-countdown')) {
    class PVCen10Countdown extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.label = this.querySelector('[data-cen10-label]');
        this.clock = this.querySelector('[data-cen10-time]');
        this.londonDate = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        if (!Number.isFinite(this.deadline) || !this.label || !this.clock) return;
        this.update();
        if (Date.now() < this.deadline) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const notice = this.closest('.product-price__promo-notice[data-promo-code="CEN10"]');
        if (!remaining) {
          window.clearInterval(this.interval);
          if (notice) {
            notice.hidden = true;
            notice.style.display = 'none';
          } else {
            this.hidden = true;
          }
          return;
        }
        const label = this.londonDate.format(now) === this.londonDate.format(this.deadline - 1)
          ? this.dataset.labelToday
          : this.dataset.labelLater;
        if (this.label.firstChild.data !== label) this.label.firstChild.data = label;
        const pad = value => String(value).padStart(2, '0');
        const hours = pad(Math.floor(remaining / 3600));
        const minutes = pad(Math.floor(remaining % 3600 / 60));
        const seconds = pad(remaining % 60);
        this.clock.firstChild.data = `${hours}:${minutes}:${seconds}`;
        this.hidden = false;
      }
    }
    customElements.define('pv-cen10-countdown', PVCen10Countdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-makeitpersonal-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-personal-notice')) {
    class PVPersonalNotice extends HTMLElement {
      connectedCallback() {
        this.update = this.update.bind(this);
        this.update();
        this.copyButton = this.querySelector('[data-promo-copy-code]');
        this.copyHandler = async event => {
          event.preventDefault();
          event.stopPropagation();
          const code = this.copyButton.dataset.promoCopyCode;
          let copied = false;
          try { await navigator.clipboard.writeText(code); copied = true; }
          catch {
            const field = document.createElement('textarea');
            field.value = code;
            field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            document.body.appendChild(field);
            field.select();
            copied = document.execCommand('copy');
            field.remove();
            this.copyButton.focus();
          }
          if (copied) {
            this.copyButton.classList.add('is-copied');
            const status = this.querySelector('[data-promo-copy-status]');
            if (status) status.textContent = this.dataset.copiedLabel;
          }
        };
        this.copyButton?.addEventListener('click', this.copyHandler);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.copyButton?.removeEventListener('click', this.copyHandler); }
      update() {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const notice = this.closest('[data-promo-id="MAKEITPERSONAL"]');
        if (notice) notice.hidden = this.dataset.preview !== 'true' && (now < start || now >= end);
        if (now < end) this.timer = setTimeout(this.update, Math.min(30000, Math.max(1, (now < start ? start : end) - now)));
      }
    }
    customElements.define('pv-personal-notice', PVPersonalNotice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-tyt-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-tyt-countdown')) {
    class PVTytCountdown extends HTMLElement {
      connectedCallback() {
        clearInterval(this.interval);
        this.start = Date.parse(this.dataset.start);
        this.deadline = Date.parse(this.dataset.deadline);
        this.clock = this.querySelector('[data-tyt-time]');
        if (!this.clock || !Number.isFinite(this.start) || !Number.isFinite(this.deadline)) return;
        this.update();
        if (Date.now() < this.deadline) {
          this.interval = setInterval(() => this.update(), 1000);
        }
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
      update() {
        const now = Date.now();
        if (now < this.start) {
          this.hidden = true;
          return;
        }
        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        if (!remaining) {
          clearInterval(this.interval);
          this.hidden = true;
          const notice = this.closest('.product-price__promo-notice[data-promo-id="TYT"]');
          if (notice) {
            notice.hidden = true;
            notice.style.display = 'none';
          }
          return;
        }
        const pad = value => String(value).padStart(2, '0');
        this.clock.textContent = [
          Math.floor(remaining / 3600),
          Math.floor(remaining % 3600 / 60),
          remaining % 60
        ].map(pad).join(':');
        this.hidden = false;
      }
    }
    customElements.define('pv-tyt-countdown', PVTytCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
